import React from 'react'
import { connect } from 'react-redux'
import { useState, useEffect, useRef, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { Portal } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import '../../css/common/dropDown.scss'
import '../../css/modal.scss'
import { faCaretDown, faCaretUp, faSearch, faCheck, faXmark } from '@fortawesome/free-solid-svg-icons'
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import EventIcon from '@mui/icons-material/Event';
import {
  SEARCH_ACTIVITY,
  SELECT_CONSIGNEE,
  SELECT_CONSIGNER,
  SEL_BOOKING_TYPE,
  SEL_PAYMENT_TYPES,
  SEL_SEARCH_BY,
  SEL_CONSIGNMENT_TYPE,
  SEL_DESTINATION_BRANCH,
  SEL_DESTINATION_CITY,
  SEL_METHOD_OF_PACKING,
  SEL_STARTING_BRANCH,
  SEL_STARTING_CITY,
} from './constants'
import {
  updateSelectedActivity,
  updateStrtCity,
  updateDestCity,
  updateStrtBrnch,
  updateDestBrnch,
  updateBookingType,
  updateParty,
  updateConsignmentType,
  updateMethodOfPackingType,
  updatePaymentType,
  updateSearchBy,
  getWeightChrg,
} from '../../store/common/common_action'
import {  selectedNearestBrnch } from '../../store/booking/booking_action'
import { getPaymentMode, getPaymentType } from './paymentsMode'
import { colors, findObjctByValueFromArrayOfObject, focusElemnt } from '../common/helper'
import {
  Booking_Type,
  Consignment_Type,
  DESTOINATION_CITY_OP,
  Driver_Name,
  Select_Destination_Branch,
  Select_Destination_City,
  SOURCE_CITY_OP,
  STATE,
  Transfer_By_Vehicle,
  Transfer_From_Branch,
  Transfer_To_Branch,
} from '../content/BranchTransfer/Lables'
import {
  BranchReceiv_Consignment_Type,
  Dispatch_From_Branch,
  Receieve_Select_Challan,
  Received_Dispatch_From_City,
  Received_To_Branch,
  Received_Transfer_From_Branch,
  Received_Transfer_From_City,
  Receive_Consignment_Type,
  Receive_Dispatch_From_Branch,
  Receive_Dispatch_From_City,
  Receive_Received_Dispatch_From_City,
  Receive_Received_To_City,
  Received_Dispatch_From_Branch,
  Receive_Received_To_Branch,
  Select_Challan,
  Select_Vehicle,
  Receive_ReceivedItem_Payment_Type,
  Receive_ReceivedItem_Consignment_Type,
  Receive_ReceivedItem_vehicleNo,
  Receive_ReceivedItem_ChallanNo,
} from '../content/BranchTransferReceive/Lables'
import { Tooltip } from '@mui/material'

const DropDownOA = ({
  showActn,
  actnTxt,
  defaultvalue,
  formElement,
  width,
  type,
  label,
  field,
  data,
  value,
  isObjArr,
  dataKey,
  idKey,
  props,
  action,
  Placeholder,
  searchPlaceholder,
  disabled,
  detail,
  portal = false,
  typeOf = false, // 1 city, 2 brnch
  slctdRowData,
  slctdRowIndex,
  callRFC,
  updateSelectedActivity,
  updateStrtCity,
  updateDestCity,
  selectedNearestBrnch,
  updateStrtBrnch,
  updateDestBrnch,
  updateBookingType,
  updateParty,
  getWeightChrg,
  id,
  crossIconId,
  nextId,
  prevId,
  autoFocus = false,
  tabIndex = undefined,
  setAllValue,
  allValues,
  onSelect = false,
  onReset = false,
  updatePaymentType,
  updateSearchBy,
  aligntOnTop = false,
  resetFlag = false,
  color = false,
  listWidth = undefined,
  tooltipTitle,
  onSelResetVal = false,
  isError = false,
  isSuccess = false,
  dropStyle = undefined,
  watchIcon = false,
  calendarIcon = false,
  direction = undefined,
  onKeyDown=false,
  ...rest
}) => {
  const defaultval = type === 'edit_vechicle_no' ? detail.jobVehicleNo : defaultvalue ? defaultvalue : ''
  const { common } = detail
  let { destCity, methodOfPckgTypes, companySettings, selBookingType, deliveybktId, loginData } = { ...common }
  const typeId = selBookingType?.typeId || deliveybktId
  let formattedlr = detail?.luggageDelivery
  const listData =
    typeOf == 1
      ? data.filter((city) => city.CitiHasCargoDelivery == 1)
      : typeOf == 2
        ? data.filter((brnch) => brnch.CargoHasDelivery == 1)
        : data
          ? data
          : []
  const list = listData
  const [searchParams, setSearchParams] = useSearchParams()
  const [showDrop, setShowDrop] = useState(false)
  const [focus, setFocus] = useState(false)
  const [blur, setBlur] = useState(true)
  const [searchInput, setSearchInput] = useState('')
  const [filteredLists, setFilteredLists] = useState([])
  const [selectedItem, setSelectedItem] = useState(defaultval)
  const [selectedObj, setSelectedObj] = useState({ [idKey]: null })
  const [cursor, setCursor] = useState(0)
  const searchResultRef = useRef(null)
  const portalRef = useRef(null)
  const input1ref = useRef(null)
  const input2ref = useRef(null)
  const dropRef = useRef(null)
  const dropdownContentRef = useRef(null)
  const debounceTimeoutRef = useRef(null);
  const [dropOpenType, setDropOpenType] = useState('down')
  const [dropPortalStyle, setDropPortalStyle] = useState({ width: 100, left: 0, top: 0, right: 'auto' })
  useEffect(() => {
    if (autoFocus) {
      input1ref.current.focus()
    }
  }, [])
  useEffect(() => {
    if (showDrop && !disabled) {
      input2ref.current.focus()
    }
  }, [showDrop])


  useEffect(() => {
    adjustDropdownPosition()
  }, [showDrop, dropdownContentRef.current]);

  useEffect(() => {
    // setting style of portal based on parents position in the dom
    if (portal) {
      const dims = dropRef.current.getBoundingClientRect()
      const style = {}
      // style.width = dims.width;
      style.width = 'max-content'
      style.top = aligntOnTop ? dims.top + window.scrollY - 210 : dims.top + window.scrollY + 34
      style.left = dims.left + window.scrollX
      setDropPortalStyle(style)
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [dropRef])

  // useEffect(() => {
  //   if(id==="AllStateofBranchTransfer"){
  //     setAllValue({ ...allValues, selectedState: data[0] })
  //   }
  // }, [])

  const adjustDropdownPosition = () => {
    if (showDrop && dropdownContentRef.current) {
      // Measure the height of the dropdown content
      const height = dropdownContentRef.current.getBoundingClientRect().height;

      // Now you can adjust the position based on the measured height
      const dims = dropRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - dims.bottom;
      const spaceAbove = dims.top + window.scrollY;

      // let style = { ...dropPortalStyle }
      let style = !!portal ? { ...dropPortalStyle } : { width: listWidth, ...dropStyle, }
      // If there's not enough space below, open upwards
      if (direction === undefined) {
        if (searchInput === '') {
          if (spaceBelow < height + 36 && spaceAbove > height + 36) {
            style.top = !!portal ? dims.top + window.scrollY - height - 36 : -(height + 36); // Open upwards
            setDropOpenType('up')
          } else {
            style.top = !!portal ? dims.top + window.scrollY + 34 : 45; // Open downwards
            setDropOpenType('down')

          }
        } else {
          if (dropOpenType === 'up') {
            style.top = !!portal ? dims.top + window.scrollY - height - 36 : -(height + 36); // Open upwards
          } else {
            style.top = !!portal ? dims.top + window.scrollY + 34 : 45; // Open downwards
          }
        }
      } else {
        if (direction === 'up') {
          style.top = -(height + 36)
        } else {
          style.top = 45
        }
      }
      if (!!portal) {
        style.width = 'max-content'
        style.left = dims.left + window.scrollX;
      }
      setDropPortalStyle(style);
    }
  };
  const handleClickOutside = (e) => {
    // adding check of portal to be handled when clicked outside
    if (
      !(
        (dropRef && dropRef.current && dropRef.current.contains(e.target)) ||
        (portal && portalRef && portalRef.current && portalRef.current.contains(e.target))
      )
    ) {
      setShowDrop(false)
    }
  }
  const scrollIntoView = (position) => {
    searchResultRef.current.parentNode.scrollTo({
      top: position,
      behavior: 'smooth',
    })
  }
  const showSuggestion = (e) => {
    e.stopPropagation();
    setShowDrop(true);

    adjustDropdownPosition();
  };
  const hideSuggestion = (e, el) => {
    setShowDrop(false)
  }
  const focusNextElement = (e) => {
    focusElemnt(nextId)
    e.preventDefault()
  }
  const focusPrevElement = () => {
    focusElemnt(prevId)
  }
  const handleDropItem = (e, el) => {
    e.stopPropagation()
    setSelectedItem(el[dataKey])
    setInpVal(el)
    setShowDrop(false)
    focusNextElement(e)
  }
  const searchItems = (searchValue) => {
    setSearchInput(searchValue)
    if (searchValue !== '') {
      const filterData = list.filter(item =>
        item[dataKey].toLowerCase().includes(searchValue.toLowerCase())
      );
      setFilteredLists(filterData);
    } else {
      setFilteredLists(list)
    }
    // Clear the previous timeout
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    // Set a new timeout to call adjustDropdownPosition after 300ms
    debounceTimeoutRef.current = setTimeout(() => {
      adjustDropdownPosition();
    }, 0);
  }

  const resetItem = () => {
    onReset && onReset()
    if (onSelResetVal) {
      onSelect && onSelect("")
    }
    setSelectedItem('')
    setSearchInput('')
    searchItems("")
    setSelectedObj({ [idKey]: null })
    if (type == SEL_DESTINATION_CITY) {
      updateDestCity({})
      updateDestBrnch({})
    }
    if (type == SEL_STARTING_CITY) {
      updateStrtCity({})
      updateStrtBrnch({})
    }
  }

  const updateActivityAndNavigate = (val) => {
    updateSelectedActivity(val)
    setSearchParams({ view: val })
  }

  const setInpVal = (val) => {
    onSelect && onSelect(val)
    setSelectedObj(val)
    setSearchInput('')//
    switch (type) {
      case SEARCH_ACTIVITY:
        updateActivityAndNavigate(val)
        break
      case SEL_STARTING_CITY:
        updateStrtCity(val)
        updateStrtBrnch({})
        break
      case SEL_STARTING_BRANCH:
        updateStrtBrnch(val)
        break
      case SEL_DESTINATION_CITY:
        updateDestCity(val)
        selectedNearestBrnch('')
        updateDestBrnch({})
        break
      case SEL_DESTINATION_BRANCH:
        updateDestBrnch(val)
        break
      case SEL_BOOKING_TYPE:
        updateBookingType(val)
        break
      case SEL_PAYMENT_TYPES:
        updatePaymentType(val)
        break
      case SEL_SEARCH_BY:
        updateSearchBy(val)
        break
      case SELECT_CONSIGNER:
        updateParty(val)
        break
      case SELECT_CONSIGNEE:
        updateParty(val, true)
        break
      case SEL_CONSIGNMENT_TYPE:
        let sCtype = val
        let slctdMethodOfPckgTypeL =
          sCtype?.DefaultMOPId !== undefined && sCtype.DefaultMOPId
            ? methodOfPckgTypes.find(({ MOPID }) => MOPID == sCtype.DefaultMOPId)
            : {}
        getWeightChrg({ CompanyID: loginData?.intCompanyID, ConsignmentTypeID: val.ConsignmentSubTypeID })

        break
      //   All case for branch transfer
      case Driver_Name:
        setAllValue({ ...allValues, selectedDriver: val })
        break
      case Select_Destination_City:
        setAllValue({ ...allValues, selectDestCity: val, selectDestBranch: { BranchName: 'All' } })
        break
      case Select_Destination_Branch:
        setAllValue({ ...allValues, selectDestBranch: val })
        break
      case Consignment_Type:
        setAllValue({ ...allValues, selectconsignmentType: val })
        break
      case Booking_Type:
        setAllValue({ ...allValues, selectBookingtype: val })
        break
      case Transfer_To_Branch:
        setAllValue({ ...allValues, transferToBranch: val, defaultValue: false })
        break
      case Transfer_By_Vehicle:
        setAllValue({ ...allValues, transferByVehicle: val,selVehicleNo:val })
        break
      case SOURCE_CITY_OP:
        setAllValue({ ...allValues, SourceCityOp: val })
        break
      case DESTOINATION_CITY_OP:
        setAllValue({ ...allValues, DestinationCityOp: val })
        break
      //   All case for branch transfer End

      //   All case for branch transfer Receive
      case Dispatch_From_Branch:
        setAllValue({ ...allValues, DFromBranch: val, resetData: false })
        break
      case BranchReceiv_Consignment_Type:
        setAllValue({ ...allValues, selectconsignmentType: val })
        break
      case Received_Transfer_From_City:
        setAllValue({ ...allValues, fromCity: val, toCity: true })
        break
      case Received_Transfer_From_Branch:
        setAllValue({ ...allValues, fromBranch: val })
        break
      case Received_To_Branch:
        setAllValue({ ...allValues, toBranch: val })
        break
      //All case for branch transfer Receive End

      //All case for  Receive page
      case Receive_Dispatch_From_City:
        setAllValue({ ...allValues, DFromCity: val, resetData: false })
        break
      case Receive_Dispatch_From_Branch:
        setAllValue({ ...allValues, DFromBranch: val })
        break
      case Receive_Consignment_Type:
        setAllValue({ ...allValues, selectconsignmentType: val })
        break
      case Receieve_Select_Challan:
        setAllValue({ ...allValues, SellectedChallanNumber: val })
        break
      case Receive_Received_Dispatch_From_City:
        setAllValue({ ...allValues, fromCity: val })
        break
      case Receive_Received_To_City:
        setAllValue({ ...allValues, toCity: val })
        break
      case Received_Dispatch_From_Branch:
        setAllValue({ ...allValues, fromBranch: val })
        break
      case Receive_Received_To_Branch:
        setAllValue({ ...allValues, toBranch: val })
        break
      case Receive_ReceivedItem_Payment_Type:
        setAllValue({ ...allValues, PaymentTypeState: val })
        break
      case Receive_ReceivedItem_Consignment_Type:
        setAllValue({ ...allValues, ItemTypeState: val })
        break
      case Receive_ReceivedItem_vehicleNo:
        setAllValue({ ...allValues, VehicleNoState: val })
        break
      case Receive_ReceivedItem_ChallanNo:
        setAllValue({ ...allValues, VoucherNoState: val })
        break
      default:
        break
    }
  }
  useEffect(() => {
    if (type == SEL_DESTINATION_BRANCH) resetItem()
  }, [destCity?.CityID])
  useEffect(() => {
    if (
      type == SEL_METHOD_OF_PACKING &&
      slctdRowData?.slctdMethodOfPckgType !== undefined &&
      slctdRowData?.slctdMethodOfPckgType.MOPName !== undefined &&
      slctdRowData?.slctdMethodOfPckgType.MOPName
    ) {
      setSelectedItem(defaultval)
      setInpVal(slctdRowData.slctdMethodOfPckgType)
    }
    // if (type == SEL_BOOKING_TYPE && defaultval && companySettings[0]?.DefaultPaymentType) {
    //   const val = getPaymentMode(companySettings[0]?.DefaultPaymentType)
    //   // updateBookingType(val)
    //   console.log(3333,defaultvalue,val)
    //   // updatePaymentType(val)
    //   // updateSearchBy(val)
    //   // setInpVal(val)
    //   // setSelectedItem(defaultval)
    // }

    if (type == SEL_STARTING_CITY && defaultval) {
      setSelectedItem(defaultval)
    }
    if (type === 'set_default') {
      setSelectedItem(defaultvalue)
    }
  }, [defaultvalue])

  const usePrevious = (value) => {
    const ref = useRef()
    useEffect(() => {
      ref.current = value
    })
    return ref.current
  }
  const prevDefaultValue = usePrevious(defaultvalue)

  useEffect(() => {
    if (defaultvalue && listData && prevDefaultValue != defaultvalue) {
      setSelectedItem(defaultval)
      const findobj = findObjctByValueFromArrayOfObject(listData, defaultval, dataKey)
      if (findobj.length) setSelectedObj(findobj[0])
    }
  }, [defaultvalue, listData])
  const prevFlag = usePrevious(resetFlag)
  useEffect(() => {
    if (resetFlag && resetFlag != prevFlag) {
      resetItem()
    }
  }, [resetFlag])

  useEffect(() => {
    if (type == SEL_CONSIGNMENT_TYPE) {
      callRFC(slctdRowData, slctdRowIndex, true)
    }
  }, [selectedObj[idKey]])
  useEffect(() => {
    if (cursor < 0 || cursor > suggestions.length || !searchResultRef) {
      return () => { }
    }
    if (searchResultRef && searchResultRef.current && searchResultRef.current.children) {
      let listItems = Array.from(searchResultRef.current.children)
      listItems[cursor] && scrollIntoView(listItems[cursor].offsetTop - 40)
    }
  }, [cursor])

  const keyboardNavigation1 = (e) => {
    if (e.key === 'ArrowDown') {
      showSuggestion(e)
    }
    if (e.key === 'ArrowUp') {
      showSuggestion(e)
    }
    if (e.key === 'Escape') {
      focusPrevElement()
    }
    if (e.key === 'Enter') {
      focusNextElement(e)
    }
  }
  const keyboardNavigation2 = (e) => {
    if (e.key === 'ArrowDown') {
      showDrop ? setCursor((c) => (c < suggestions.length - 1 ? c + 1 : 0)) : showSuggestion()
    }

    if (e.key === 'ArrowUp') {
      setCursor((c) => (c > 0 ? c - 1 : 0))
    }

    if (e.key === 'Escape') {
      hideSuggestion()
      input1ref.current.focus()
    }

    if (e.key === 'Enter' && cursor > -1) {
      setSelectedItem(suggestions[cursor][dataKey])
      setInpVal(suggestions[cursor])
      hideSuggestion()
      nextId ? focusNextElement(e) : input1ref.current.focus()
    }
  }
  const labelTxyt =
    field === 'compulsory' ? (
      <span>
        {label}
        <span style={{ color: 'red', paddingLeft: '5px' }}>*</span>
      </span>
    ) : field === 'infoTitle' ?
      (
        <div style={{ display: 'flex' }}>
          {label}
          <Tooltip title={tooltipTitle}
            PopperProps={{
              sx: {
                position: 'absolute !important',
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px',
                  whiteSpace: 'pre-line'
                }
              }
            }}
            placement={'bottom-start'}>

            <span style={{ margin: '0px 4px' }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <mask id="mask0_1807_21156" style={{ "mask-type": "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
                  <rect y="0.0947266" width="16" height="16" fill="#D9D9D9" />
                </mask>
                <g mask="url(#mask0_1807_21156)">
                  <path d="M7.99992 11.4287C8.18881 11.4287 8.34714 11.3648 8.47492 11.237C8.6027 11.1093 8.66658 10.9509 8.66658 10.762V8.09538C8.66658 7.90649 8.6027 7.74816 8.47492 7.62038C8.34714 7.4926 8.18881 7.42871 7.99992 7.42871C7.81103 7.42871 7.6527 7.4926 7.52492 7.62038C7.39714 7.74816 7.33325 7.90649 7.33325 8.09538V10.762C7.33325 10.9509 7.39714 11.1093 7.52492 11.237C7.6527 11.3648 7.81103 11.4287 7.99992 11.4287ZM7.99992 6.09538C8.18881 6.09538 8.34714 6.03149 8.47492 5.90371C8.6027 5.77593 8.66658 5.6176 8.66658 5.42871C8.66658 5.23982 8.6027 5.08149 8.47492 4.95371C8.34714 4.82593 8.18881 4.76204 7.99992 4.76204C7.81103 4.76204 7.6527 4.82593 7.52492 4.95371C7.39714 5.08149 7.33325 5.23982 7.33325 5.42871C7.33325 5.6176 7.39714 5.77593 7.52492 5.90371C7.6527 6.03149 7.81103 6.09538 7.99992 6.09538ZM7.99992 14.762C7.0777 14.762 6.21103 14.587 5.39992 14.237C4.58881 13.887 3.88325 13.412 3.28325 12.812C2.68325 12.212 2.20825 11.5065 1.85825 10.6954C1.50825 9.88427 1.33325 9.0176 1.33325 8.09538C1.33325 7.17315 1.50825 6.30649 1.85825 5.49538C2.20825 4.68427 2.68325 3.97871 3.28325 3.37871C3.88325 2.77871 4.58881 2.30371 5.39992 1.95371C6.21103 1.60371 7.0777 1.42871 7.99992 1.42871C8.92214 1.42871 9.78881 1.60371 10.5999 1.95371C11.411 2.30371 12.1166 2.77871 12.7166 3.37871C13.3166 3.97871 13.7916 4.68427 14.1416 5.49538C14.4916 6.30649 14.6666 7.17315 14.6666 8.09538C14.6666 9.0176 14.4916 9.88427 14.1416 10.6954C13.7916 11.5065 13.3166 12.212 12.7166 12.812C12.1166 13.412 11.411 13.887 10.5999 14.237C9.78881 14.587 8.92214 14.762 7.99992 14.762Z" fill="#0086FF" />
                </g>
              </svg>
            </span>
          </Tooltip>
        </div>
      )
      : (
        label
      )
  const suggestions = searchInput !== '' ? filteredLists : list
  // making this as a renderer function to be used as portal
  const dropDownRenderer = (props) => (
    <div className="drop--wrapper" style={dropPortalStyle}>
      <div className="drop--search">
        <input
          ref={input2ref}
          type="text"
          className="search"
          placeholder={searchPlaceholder}
          value={searchInput}
          autoComplete="new-password"
          onChange={(e) => searchItems(e.target.value)}
          onKeyDown={(e) => keyboardNavigation2(e)}
          onFocus={() => {
            setFocus(true)
            setBlur(false)
          }}
          onBlur={() => {
            setBlur(true)
            setFocus(false)
          }}
        />
        <div className="search--icon">
          <FontAwesomeIcon icon={faSearch} color={'#777'} />
        </div>
      </div>
      <div className="drop--content scroll" ref={dropdownContentRef}>
        <ul className="list-group" ref={searchResultRef}>
          {suggestions.length > 0 ? (
            suggestions.map((el, index) => (
              <li
                key={`drop--item_${el[dataKey]}_${el[idKey]}}`}
                className={`drop--item ${el[idKey] === selectedObj[idKey] ? 'selected' : ''} ${cursor === index ? 'highlighted' : ''}`}
                onClick={(e) => handleDropItem(e, el)}
              >
                <div className={`search--checkbox ${el[idKey] === selectedObj[idKey] ? 'checked' : ''}`}>
                  {
                    <span className="check">
                      <FontAwesomeIcon icon={faCheck} color={'#fff'} />
                    </span>
                  }
                </div>
                <div>{el[dataKey]}</div>
              </li>
            ))
          ) : (
            <div className="not--found">No results found</div>
          )}
        </ul>
      </div>
    </div>
  )
  return (
    <div
      className={`dropdown--wrapper ${isSuccess ? "successDropDown" : ""} ${isError ? "errorDropDown" : ""} ${disabled ? 'disabled-wrapper' : ''} ${formElement === 'input' ? 'inputDropdownCustomise' : ''} ${showDrop ? 'active' : ''
        }`}
      style={{ width: width, minWidth: rest.minWidth }}
      ref={dropRef}
    >
      <input
        type="text"
        className={`inp--field ${disabled ? 'disable' : ''} ${focus ? 'active' : ''}`}
        value={value ? value : selectedItem}
        readOnly
        onClick={showSuggestion}
        onKeyDown={onKeyDown ? onKeyDown : keyboardNavigation1}
        tabIndex={tabIndex}
        id={id}
        ref={input1ref}
        onFocus={() => {
          if (disabled && nextId) {
            focusElemnt(nextId)
          }
        }}
        style={watchIcon || calendarIcon ? { backgroundColor: disabled === false && color === true ? colors[typeId - 1] : '', paddingLeft: '32px' } : { backgroundColor: disabled === false && color === true ? colors[typeId - 1] : '' }}
      />
      {watchIcon &&
        <div className="cross--icon" style={{ left: "2px" }}>
          <span className="cross">
            <AccessTimeRoundedIcon />
          </span>
        </div>
      }
      {calendarIcon &&
        <div className="cross--icon" style={{ left: "2px" }}>
          <span className="cross">
            <EventIcon />
          </span>
        </div>
      }
      {selectedItem && !disabled && !rest?.noCross ? (
        <div className="cross--icon" onClick={resetItem} id={crossIconId}>
          <span className="cross">
            <FontAwesomeIcon icon={faXmark} color={isError ? "red" : isSuccess ? "#16B851" : '#777'} />
          </span>
        </div>
      ):<></>}
      {!showActn && !disabled ? (
        <div className="caret--icon">
          {showDrop ? <FontAwesomeIcon icon={faCaretUp} color={isError ? "red" : isSuccess ? "#16B851" : '#777'} /> : <FontAwesomeIcon icon={faCaretDown} color={isError ? "red" : isSuccess ? "#16B851" : '#777'} />}
        </div>
      ) : (
        <div className="actn--Txt">{actnTxt}</div>
      )}
      <div className={`inp--label ${focus ? 'active' : selectedItem && blur ? ' filled' : watchIcon || calendarIcon ? 'watch--icon' : ''}`} style={{ pointerEvents: field === 'infoTitle' ? 'all' : 'none' }}>{labelTxyt}</div>
      {!disabled &&
        // For portal using portal value else whatever was earlier will be rendered
        // added parent class name as styles were dependent on that
        (!!portal ? (
          <Portal container={document.getElementById('root')}>
            <div className="dropdown--wrapper dropdown--wrapper--portal" ref={portalRef} style={{ display: showDrop ? 'block' : 'none' }}>
              {dropDownRenderer()}
            </div>
          </Portal>
        ) : (
          <div className="dropdown--wrapper dropdown--wrapper--portal" ref={portalRef} style={{ display: showDrop ? 'block' : 'none' }}>
            {dropDownRenderer()}
          </div>
        ))}
    </div>
  )
}

const mapStateToProps = (detail) => ({ detail })
const mapDispatchToProps = {
  updateSelectedActivity,
  updateStrtCity,
  updateDestCity,
  updateStrtBrnch,
  updateDestBrnch,
  updateBookingType,
  updateParty,
  updateConsignmentType,
  updateMethodOfPackingType,
  updatePaymentType,
  updateSearchBy,
  selectedNearestBrnch,
  getWeightChrg,
}
export default connect(mapStateToProps, mapDispatchToProps)(DropDownOA)